// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605221011/js/" + chunkId + "." + {"44":"9f34505d","225":"617ec9c8","481":"06077306","486":"6086501e","770":"89d1dacf"}[chunkId] + ".0.7235167528812279.chunk.js";
};